GameView    = require "views/base/game"
{ DraggyView }  = require("views/components/draggy")

class SliderView extends GameView
  template: require("./template")

  events:
    "iostap .btn-done": "endGame"

  serialize: ->
    d = super

    d.slider.increment = parseFloat(d.slider.increment, 10) or 1
    d.slider.min = parseFloat(d.slider.min)
    d.slider.max = parseFloat(d.slider.max)
    d.slider.min = 0 if _.isNaN(d.slider.min)
    d.slider.max = 10 if _.isNaN(d.slider.max)

    if d.slider.min > d.slider.max
      min = d.slider.min
      d.slider.min = d.slider.max
      d.slider.max = min

    d.range = d.slider.max - d.slider.min
    d.notches = Math.round(d.range / d.slider.increment)

    d.labels =
      _.nearest(_.factors(d.notches).map((m) -> m + 1), d.slider.labels)

    d.labelValues = [0...d.labels].map (i) ->
      value = new Big(Math.round(i * d.notches / (d.labels - 1)))
      value = value.mul(d.slider.increment).add(d.slider.min)
      value
    d

  beforeShow: ->
    @trigger("ui", flexibleHeight: true)

  beforeHide: ->
    @trigger("ui", flexibleHeight: false)

  show: ->
    super

    delete @currentValue

    @setEl @findOne(".slider"), "slider"
    @setEl @findOne(".slider-knob-input"), "knob-input"
    @setEl @findOne(".slider-knob-value"), "knob-value"
    @setEl @findOne(".slider-knob-answer"), "knob-answer"

    @createDraggy()
    @draggy.reset(x: @draggy.offset.width / 2)

    @enterGame()

  createDraggy: ->
    width = @getEl("slider").offsetWidth

    @draggy = new DraggyView
      el: @getEl("slider")
      minX: 0
      maxX: width
      lock: "y"
      isParent: true

    if @options.config().direction is "rtl"
      @draggy.reset x: width
      @transform @getEl("knob-input"), x: width
      @getEl("knob-input").offsetWidth

    @listenTo @draggy, "drag", @onDrag
    @listenTo @draggy, "drop", @onDrop
    @listenTo this, "resize", @onResize

  onDrag: (draggy, isInitialDrag) ->
    @currentValue = @roundValue(draggy)

    @labelEl @getEl("knob-value"), @currentValue
    @transform @getEl("knob-input"),
      x: draggy.x
      scale: 1.25
      transition: if isInitialDrag then "all 300ms" else "none"

  onDrop: (draggy, isReset) ->
    x = @roundPos(draggy)

    if draggy.x isnt x and not isReset
      draggy.reset({x})
    else
      @transform @getEl("knob-input"),
        x: draggy.x
        transition: "all 300ms"

      if @currentValue?
        @labelEl @getEl("knob-value"), @currentValue
        @setState("touched")

  roundValue: (draggy) ->
    {increment, min, max} = @options.data.slider

    Big(max - min)
      .mul(@roundPercent(draggy))
      .div(increment)
      .round()
      .mul(increment)
      .plus(min)

  roundPos: (draggy) ->
    percent = @roundPercent(draggy)
    percent = 1 - percent if @options.config().direction is "rtl"
    percent * draggy.offset.width

  roundPercent: (draggy) ->
    {increment, min, max} = @options.data.slider

    max     = Big(max).sub(min).div(increment).round().mul(increment).plus(min)
    percent = _.limit(draggy.x / draggy.offset.width, 0, 1) or 0
    steps   = Big(max).sub(min).div(increment).valueOf()
    percent = if steps > 0 then Big(steps).mul(percent).round().div(steps) else 0
    percent = 1 - percent if @options.config().direction is "rtl"
    percent

  onResize: (e, data) ->
    {min, max} = @options.data.slider
    percent = (@currentValue - min) / (max - min) or 0.5
    @draggy.options.maxX = @draggy.el.offsetWidth
    @draggy.reset(x: percent * @draggy.el.offsetWidth)
    @animateAnswerKnob(@getEl("knob-answer"))

  labelEl: (el, value) ->
    {prefix, suffix, decimals} = @options.data.slider

    decimals = parseFloat(decimals, 10) or 0
    value = parseFloat(value, 10).toFixed(decimals) if decimals > 0
    el.innerHTML = "#{prefix}#{value}#{suffix}"

  isCorrect: ->
    @options.data?.answer?.value? and
    @currentValue? and
    @currentValue.eq @options.data.answer.value

  showAnswer: ->
    @transform @getEl("knob-answer"), x: @draggy.x
    @animateAnswerKnob(@getEl("knob-answer"))

    @draggy.lock()

  animateAnswerKnob: (el) ->
    {answer, slider} = @options.data
    return unless answer

    {increment, min, max} = slider
    max     = Big(max).sub(min).div(increment).round().mul(increment).plus(min)
    percent = (answer.value - min) / (max - min)
    percent = 1 - percent if @options.config().direction is "rtl"

    el.offsetLeft

    @transform el,
      x: percent * @draggy.offset.width
      transition: if @draggy.locked then "none" else "all 600ms"

  answerDetails: ->
    questions    = @options.metadata?.questions or []
    return [] unless questions.length > 0

    question         = questions[0]
    correct          = @isCorrect()
    value            = Number(@currentValue)

    answer           = _.find question.answers, (a) -> a.correct is correct
    answer.content   = value
    details          = question: question.question, answer: answer

    [ details ]

  endGame: ->
    super

    @submit()

module.exports = SliderView
